import { Close, InfoOutlined } from '@mui/icons-material';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, IconButton, Switch } from '@mui/material';
import { Component } from 'react';
import { switchStyle } from '../../utils/styles';

export default class UploadCensusConfirmationModal extends Component {
    state = {
        enrollNewHiresInWelcomeSequence: true
    }

    handleToggleEnrollNewHires = (event) => {
        this.setState({ enrollNewHiresInWelcomeSequence: event.target.checked });
    }

    handleAction = (e) => {
        const { action } = this.props;
        const { enrollNewHiresInWelcomeSequence } = this.state;
        action(e, { enrollNewHiresInWelcomeSequence });
    }

    render() {

        const { onCancel, disabled, data, setConfirmationMessage, confirmationMessage } = this.props;
        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                onClose={onCancel}
                fullWidth
            >
                <DialogTitle id="confirm-census" sx={{ m: 0, p: 2 }}>
                    Confirm census file processing
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'black.900'
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                    <DialogContentText id="confirm-census-description" style={{ marginTop: -20, fontSize: 16, marginBottom: 20 }}>
                        Verify the details below before processing
                    </DialogContentText>

                    <DialogContentText id="alert-dialog-description" style={{ marginTop: -20, fontSize: 16 }}>
                        <ul style={{ gap: 10, flexDirection: 'column', display: 'flex', paddingLeft: 20 }}>
                            <li><strong>Organization / Domain: </strong>{data.domainName}</li>
                            <li><strong>Filename: </strong>{data.fileName}</li>
                            <li><strong>Prior census employee count: </strong>{data.previousCensusEmployeeCount.toLocaleString()}</li>
                            <li><strong>New census employee count: </strong>{data.newCensusEmployeeCount.toLocaleString()}</li>
                            <li><strong>New hire in uploaded census: </strong>{data.newHires.toLocaleString()}</li>
                            <li><strong>Borrowers terminations in uploaded census: </strong>{data.terminations.toLocaleString()}</li>
                            <li><strong>Leads terminations in uploaded census: </strong>{data.archiveCount.toLocaleString()}</li>
                        </ul>
                    </DialogContentText>

                    {/* New Hires Welcome Email Enrollment Toggle - Only show when new hires are detected */}
                    {data.newHires > 0 && (
                        <div style={{ marginTop: 10, marginBottom: 10 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.enrollNewHiresInWelcomeSequence}
                                        onChange={this.handleToggleEnrollNewHires}
                                        color="primary"
                                        sx={switchStyle}
                                    />
                                }
                                label="Enroll new hires in the welcome email sequence?"
                                style={{ fontSize: 16 }}
                            />
                        </div>
                    )}


                    <DialogContentText >
                        <Alert variant='filled' severity="warning" sx={{
                            backgroundColor: '#FFCC80', // light orange
                            color: '#663C00', // dark text for contrast
                            fontSize: 12
                        }} icon={<InfoOutlined color='warning' />} >
                            Make sure this is the correct census file for <b>{data.domainName}</b>
                        </Alert>
                    </DialogContentText>

                    {/* <DialogContent className="col-12"> */}
                    <div className="">
                        <label>Type the word <b>confirm</b> to proceed</label>
                        <input
                            disabled={false}
                            type="text"
                            className="form-control"
                            value={confirmationMessage}
                            onChange={(e) => setConfirmationMessage(e.target.value)}
                            name="confirm"
                        />
                    </div>
                    {/* </DialogContent> */}

                    <DialogContentText id="alert-dialog-description" style={{ fontSize: 16 }}>
                        Click Confirm to process the Census file. New hires and terminations will be updated, and emails sent.
                    </DialogContentText>

                </DialogContent>
                <Divider />

                <DialogActions style={{ justifyContent: 'space-between', padding: 20 }}>

                    <Button onClick={onCancel} variant="outlined" color="warning">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={this.handleAction}
                        color="primary"
                        autoFocus
                        disabled={disabled}
                    >
                        Confirm & Process
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }
}
